import ReactMarkdown from 'react-markdown';
import { Heading } from '@/Components/UI/Heading';

type MarkdownProps = {
    children: string;
}

export const Markdown = ({ children }: MarkdownProps) => {
    return (
        <ReactMarkdown
            children={children}
            components={{
                h1: ({ ...props }) => <Heading level={1} {...props} />,
                h2: ({ ...props }) => <Heading level={2} {...props} />,
                h3: ({ ...props }) => <Heading level={3} {...props} />,
                h4: ({ ...props }) => <Heading level={4} {...props} />,
                h5: ({ ...props }) => <Heading level={5} {...props} />,
                h6: ({ ...props }) => <Heading level={6} {...props} />,
                p: ({ ...props }) => <p className={'block'} {...props} />,
                ul: ({ ...props }) => <ul className={'list-disc list-inside pl-5'} {...props} />
            }} />
    );
};
